module.exports = __webpack_public_path__ + "static/img/swf.fb543d4c.png";